module.exports = __webpack_public_path__ + "img/HiwaQader-AsmanakayAna.23754e00.jpg";